import { keyBy } from 'lodash-es';
export var CLICK = 'click';
export var HOVER = 'hover';
export var TIMER = 'timer';
export var DOUBLE_TAP = 'doubletap';
export var SWIPE_LEFT = 'swipeleft';
export var SWIPE_RIGHT = 'swiperight';
export var SWIPE_UP = 'swipeup';
export var SWIPE_DOWN = 'swipedown';
export var PINCH_IN = 'pinchin';
export var PINCH_OUT = 'pinchout';
var touchActions = keyBy([
    DOUBLE_TAP,
    SWIPE_LEFT,
    SWIPE_RIGHT,
    SWIPE_UP,
    SWIPE_DOWN,
    PINCH_IN,
    PINCH_OUT,
]);
export function isTouchAction(action) {
    return action in touchActions;
}
